import { create, test, enforce } from "vest";

import { EMAIL_REGEXP } from "@/constants/regex";

export default create((data = {}) => {
  test("email", () => {
    enforce(data.email)
      .isNotNull()
      .message("Email is required")
      .isNotBlank()
      .message("Please enter a valid email address")
      .condition((value) => EMAIL_REGEXP.test(value));
  });

  test("password", () => {
    enforce(data.password)
      .isNotNull()
      .message("Password is required")
      .isNotBlank();
  });

  test("recaptchaToken", () => {
    enforce(data.recaptchaToken).isNotNull().isNotBlank();
  });
});
